<app-base-group-mgmt-component [Title]="'Groups'" [Objects]="model.Groups" [groups]="groups">
  <ng-template let-item>
    <td>{{item.Name}}</td>
  </ng-template>
</app-base-group-mgmt-component>
<app-base-group-mgmt-component [Title]="'Keys and labels'" [Objects]="model.Keys" [groups]="keys" [filtered]="FreeKeys"
                               [groupsUsedForObjectsSelection]="KeyGroups">
  <ng-template let-item>
    <td>{{item.Name}}&nbsp;{{item.Comment}}</td>
  </ng-template>
</app-base-group-mgmt-component>
